export default __webpack_public_path__ + "static/media/Droper.aa0fc122.svg";